import React, { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Pagina404 } from "../navegacion/pagina404";
import { NavbarInterna } from "../componentes/navbarInterna";
import { FooterInterno } from "../componentes/footerInterno";
import { CrearAdministradores } from "../navegacionInterna/administradores";
import { GestionAsociaciones } from "../navegacionInterna/asociaciones";
import { GestionCarreras } from "../navegacionInterna/altaCarrera";
import { Administracion } from "../navegacionInterna/administracion";
import { AltaPilotos } from "../navegacionInterna/altaPilotos";
import { AltaResultados } from "../navegacionInterna/altaResultados";
import { AltaCircuito } from "../navegacionInterna/altaCircuitos";
import { AltaCampeonato } from "../navegacionInterna/altaCampeonato";
import { SeleccionarAsociacion } from "../navegacionInterna/seleccionarAsociacion";
import { ResultadosPorCampeonatoCategoria } from "../navegacionInterna/resultadosCampeonatos";
import { AlertasGenerales } from "../componentes/alertas";
import { useSesion } from "./userContexto";
import { AltaCategoria } from "../navegacionInterna/altaCategoria";
import { Publicidades } from "../navegacionInterna/publicidades";
import { Grupos } from "../navegacionInterna/altaGrupos";
import { PreInscriptos } from "../navegacionInterna/altaPre-inscriptos";
import { Notificaciones } from "../navegacionInterna/notificaciones";


export const CompRutasAdm = () => {
    const { sesion } = useSesion();
    const [alerta, setAlerta] = useState(null);
    // console.log("sesion", sesion.permisos?.map(c => c))
return (
    <>
        <NavbarInterna sesion={sesion} setAlerta={setAlerta}/>
      <Routes>
        {/* Rutas principal */}


        {(sesion.id_asociacion === "" || sesion.id_asociacion === null ) ?
            <>
                <Route path="/administradores" element={<CrearAdministradores sesion={sesion} setAlerta={setAlerta}/>} />
                <Route path="/asociaciones" element={<GestionAsociaciones sesion={sesion} setAlerta={setAlerta}/>} />
                <Route path="/publicidades" element={<Publicidades sesion={sesion} setAlerta={setAlerta}/>} />
                <Route path="/" element={<SeleccionarAsociacion sesion={sesion} setAlerta={setAlerta}/>} />
                <Route path="*" element={<Pagina404 /> } />
            </>
            :
            <>
            <Route path="*" element={<Pagina404 />} />
            {sesion.permisos?.includes("CAMPEONATOS") || sesion.super_admin === true ? (
                <Route path="/campeonato" element={<AltaCampeonato   sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            {sesion.permisos?.includes("CIRCUITOS") || sesion.super_admin === true ? (
                <Route path="/circuito" element={<AltaCircuito sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            {sesion.permisos?.includes("CATEGORIAS") || sesion.super_admin === true ? (
                <Route path="/categoria" element={<AltaCategoria  sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            {sesion.permisos?.includes("PILOTOS") || sesion.super_admin === true ? (
                <Route path="/pilotos" element={<AltaPilotos sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            {sesion.permisos?.includes("CARRERAS") || sesion.super_admin === true ? (
                <Route path="/carreras" element={<GestionCarreras sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            {sesion.permisos?.includes("GESTION_DE_CARRERAS") || sesion.super_admin === true ? (
                <Route path="/inscripciones" element={<AltaResultados sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            {sesion.permisos?.includes("RESULTADOS_GENERALES") || sesion.super_admin === true ? (
                <Route path="/resultados" element={<ResultadosPorCampeonatoCategoria  sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            {sesion.permisos?.includes("GRUPOS") || sesion.super_admin === true ? (
                <Route path="/grupos" element={<Grupos sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            {sesion.permisos?.includes("PRE_INSCRIPCIONES") || sesion.super_admin === true ? (
                <Route path="/pre-inscriptos" element={<PreInscriptos sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            {sesion.permisos?.includes("NOTIFICACIONES") || sesion.super_admin === true ? (
                <Route path="/notificaciones" element={<Notificaciones sesion={sesion} setAlerta={setAlerta}/>} />
            ) : (
                <Route path="*" element={<Pagina404 />} />
            )}

            <Route path="/" element={<Administracion sesion={sesion} setAlerta={setAlerta}/>} />



            </>
        }

        {/* <Route path="/altaReglamento" element={<AltaReglamento />} /> */}

      </Routes>
      <AlertasGenerales inAlerta={alerta}/>

      <FooterInterno sesion={sesion} setAlerta={setAlerta}/>
      </>
  );
};
